import React from 'react';
import css from '../ResearchWinesPage.module.css';

function FilterByWineType({
  selectedWineTypes,
  setSelectedWineTypes
}) {

  const wineTypes = [
    {
      value: "red",
      type: "Red Wine"
    },
    {
      value: "white",
      type: "White Wine"
    },
    {
      value: "rosé",
      type: "Rosé Wine"
    },
    {
      value: "sparkling",
      type: "Sparkling"
    },
    {
      value: "other",
      type: "Other, e.g. Orange, Desert, etc."
    },
  ]

  const handleOnChange = (e) => {
    if(e.target.checked){
      setSelectedWineTypes(e.target.name)
      // setSelectedWineTypes([...selectedWineTypes, e.target.name])
    } else {
      setSelectedWineTypes("")
      // setSelectedWineTypes([...selectedWineTypes].filter(x => x !== e.target.name))
    }
  }

  return (
    <div>
      <h3>Wine Type</h3>
      <div>
        {wineTypes.map(t => (
          <div key={t.value} style={{display: 'flex', alignItems: 'center'}}>
            <input
              type="checkbox"
              id={t.value}
              name={t.value}
              onChange={handleOnChange}
              checked={selectedWineTypes.includes(t.value.toLowerCase())}
              style={{display: 'inline-block', width: 'auto', marginRight: "10px"}}
            />
            <label htmlFor={t.value}>{t.type}</label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterByWineType
